
/* injects from baggage-loader */

import React, {cloneElement, Children, Fragment} from 'react'
import PropTypes from 'prop-types'
import {createPortal} from 'react-dom'
import Tooltip from 'components/Tooltip'

export default class WithTooltip extends React.Component {
  static propTypes = {
    title: PropTypes.node,
    align: Tooltip.propTypes.align,
    style: Tooltip.propTypes.style,
    place: Tooltip.propTypes.place,
    position: Tooltip.propTypes.position,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    align: Tooltip.defaultProps.align,
    style: Tooltip.defaultProps.style,
    place: Tooltip.defaultProps.place,
    position: Tooltip.defaultProps.position
  }

  constructor(props) {
    super(props)
    this.state = {
      node: null
    }
  }

  componentWillUnmount() {
    this.removePortal()
  }

  render() {
    const {title, disabled} = this.props
    if (disabled || !title) return this.props.children

    return (
      <Fragment>
        {this.renderChild()}
        {this.renderPortal()}
      </Fragment>
    )
  }

  renderChild() {
    const onMouseEnter = this.onMouseEnter
    const onMouseLeave = this.onMouseLeave
    return cloneElement(Children.only(this.props.children), {
      onMouseEnter,
      onMouseLeave,
      ref: 'tooltip_holder'
    })
  }

  renderPortal() {
    const {node} = this.state

    if (node) {
      const rect = this.refs.tooltip_holder.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const {title, align, style, place, position} = this.props
      const styles = {
        position: 'absolute',
        left: rect.left,
        top: rect.top + scrollTop,
        width: rect.width,
        height: rect.height,
        'pointerEvents': 'none'
      }

      return createPortal(
        <div style={styles}>
          <Tooltip place={place} align={align} style={style} position={position}>{title}</Tooltip>
        </div>,
        node
      )
    }
  }

  onMouseEnter = evt => {
    const {onMouseEnter} = Children.only(this.props.children).props
    onMouseEnter && onMouseEnter(evt)
    this.removePortal()
    const node = document.createElement('div')
    document.body.appendChild(node)
    this.setState({node})
  }

  onMouseLeave = evt => {
    const {onMouseLeave} = Children.only(this.props.children).props
    onMouseLeave && onMouseLeave(evt)
    this.removePortal()
  }

  removePortal() {
    const {node} = this.state
    if (node) {
      document.body.removeChild(node)
      this.setState({node: null})
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/WithTooltip/index.js